import DgEditForm from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgEditForm.install = function (Vue) {
  Vue.component(DgEditForm.name, DgEditForm)
}
export default DgEditForm

export * from './src/main.js'

export { DgEditForm }
